import { render, staticRenderFns } from "./partsRecordManager.vue?vue&type=template&id=ae22cb80&scoped=true&"
import script from "./partsRecordManager.vue?vue&type=script&lang=ts&"
export * from "./partsRecordManager.vue?vue&type=script&lang=ts&"
import style0 from "./partsRecordManager.vue?vue&type=style&index=0&id=ae22cb80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae22cb80",
  null
  
)

export default component.exports